"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTagStyles = void 0;
var core_1 = require("@material-ui/core");
var _colors_1 = require("../../../style/commons/_colors");
exports.useTagStyles = (0, core_1.makeStyles)(function () { return ({
    tagContainer: {
        boxShadow: 'inherit',
        borderRadius: '4px',
        fontFamily: 'Roboto',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        padding: '2px 8px',
    },
    small: {
        fontSize: '12px',
    },
    medium: {
        fontSize: '14px',
    },
    error: {
        backgroundColor: _colors_1.lightDanger,
        color: _colors_1.darkSecondary,
    },
    information: {
        backgroundColor: _colors_1.lightInfo,
        color: _colors_1.darkSecondary,
    },
    success: {
        backgroundColor: _colors_1.lightSuccess,
        color: _colors_1.darkSecondary,
    },
    warning: {
        backgroundColor: _colors_1.lightWarning,
        color: _colors_1.darkSecondary,
    },
    marketing: {
        backgroundColor: _colors_1.mediumPink,
        color: _colors_1.white,
    },
}); });
